module.exports = __webpack_public_path__ + "2021120:beba53acebe35c990492/img/Luminary-homepage-L-1024x576.e35fbb3.png";